export default __webpack_public_path__ + "static/media/Group 33.b7d603d4.png";